import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { config } from '../../config/envs';
import { impersonateUser } from '../api';
import { buildImpersonationUrl } from '../helpers/impersonation';
import {
  IMPERSONATE_ERROR_MESSAGES,
  IMPERSONATE_TEXTS,
} from '../constants/impersonate';

const REDIRECT_DELAY_MS = 1000;

export const useImpersonate = () => {
  const [isLoading, setIsLoading] = useState(false);

  const impersonate = useCallback(async (target) => {
    setIsLoading(true);

    try {
      const { data } = await impersonateUser(target);
      const impersonationUrl = buildImpersonationUrl(config.app.frontUrl, data);

      toast.info(IMPERSONATE_TEXTS.REDIRECTING);

      setTimeout(() => {
        window.open(impersonationUrl, '_blank', 'noopener,noreferrer');
      }, REDIRECT_DELAY_MS);
    } catch (err) {
      const errorCode = err?.response?.data?.error;

      toast.error(
        IMPERSONATE_ERROR_MESSAGES.get(errorCode) ??
          IMPERSONATE_TEXTS.DEFAULT_ERROR,
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { impersonate, isLoading };
};
